<div class="overlay" *ngIf="isOpen">
  <div class="modal-shell">
    <button type="button" class="close-btn" (click)="onClose()" aria-label="Close modal">
      ✕
    </button>

    <div class="header-block">
      @if (mode === "CREATE") {
        <h2>Create New Role</h2>
        <p>Define role details and assign permissions</p>
      } @else if (mode === "UPDATE") {
        <h2>Update Existing Role</h2>
        <p>Edit role details and assign permissions</p>
      } @else if (mode === "VIEW") {
        <h2>View Existing Role</h2>
        <p>View role details and assign permissions</p>
      }
    </div>

    @if (isLoadingRoleData) {
      <div class="w-full h-16 text-center">
        <div class="flex flex-col items-center gap-3">
          <div
            class="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-teal-600"
          ></div>
          <p class="text-sm font-medium text-slate-500">Loading users...</p>
        </div>
      </div>
    } @else {
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="content-area">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div class="field-group">
            <label>Role Name</label>
            <input
              [appCharLength]
              class="cursor-pointer disabled:cursor-not-allowed disabled:!bg-gray-50"
              type="text"
              formControlName="roleName"
              placeholder="Enter role name"
            />
          </div>
  
          <div class="field-group">
            <label>Status</label>
            <div class="select-wrap">
              <select 
                formControlName="status"
                class="cursor-pointer disabled:cursor-not-allowed disabled:!bg-gray-50"
              >
                <option value="Active">-- Active --</option>
                <option value="Inactive">-- Inactive --</option>
              </select>
            </div>
          </div>
        </div>
  
        <div class="field-group mt-4">
          <label>Description</label>
          <textarea 
            [appCharLength]
            class="py-2 cursor-pointer disabled:cursor-not-allowed disabled:!bg-gray-50"
            formControlName="description"
            placeholder="Enter role description"
          >
          </textarea>
        </div>
  
        <app-permission-matrix
          [rows]="permissionRows"
          (rowsChange)="onRowsChange($event)"
          [disable]="mode === 'VIEW'"
          [action]="(mode === 'VIEW' && 'Viewing Selected Permissions') || 'Assign Permissions'"
        ></app-permission-matrix>
  
        @if (mode === "CREATE") {
          <button type="submit" class="mt-4 w-full page-btn page-btn-primary">
            <span>Create Role</span>
            <span class="arrow">→</span>
          </button>
        } @else if (mode === "UPDATE") {
          <button type="submit" class="mt-4 w-full page-btn page-btn-primary">
            <span>Update Role</span>
            <span class="arrow">→</span>
          </button>
        }
      </form>
    }
  </div>
</div>
